export const PROMPT_SUB_TEMPLATE_ID = '-1';

// These "template" key might be returned by AC in template classification flow if the prompt is invalid or requires localization
export const TEMPLATE_KEY_UNSUPPORTED_PROMPT =
  'question_or_statement_without_direct_or_indirect_request_for_content_generation';
export const TEMPLATE_KEY_LOCALIZATION = 'localize_or_translate_any_content';

export const TEMPLATE_TYPE = {
  generationTool: 'generation_tool',
  subTemplate: 'sub_template',
  customMultiPrompt: 'custom_multi_prompt',
} as const;
export type TemplateType = (typeof TEMPLATE_TYPE)[keyof typeof TEMPLATE_TYPE];
